import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="px-4 md:px-6 py-20">
      <div className="max-w-[1280px] mx-auto text-center">
        <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-6">
          <i className="ri-emotion-sad-line text-4xl"></i>
        </div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">页面未找到</h1>
        <p className="text-foreground-600 mb-8">抱歉，您访问的页面不存在或已被移除。</p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/"
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
          <Link
            to="/category/shaonian"
            className="px-6 py-3 rounded-full bg-background-100 border border-background-300 text-foreground-700 text-sm font-medium hover:bg-primary-50 hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            浏览漫画
          </Link>
        </div>
      </div>
    </main>
  );
}